import { Component, OnInit, OnDestroy } from '@angular/core';
import { IxellAPIService, IHistoryV1 } from 'src/app/tools/api.service';
import { HeaderService } from 'src/app/tools/header.service';
import { ErrorService } from 'src/app/tools/error.service';
import { bankInfo } from 'src/app/models/bankInfo';

@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit, OnDestroy {

    historySub: any;
    ribSub: any;
    orderHistory: IHistoryV1[] = [];
    quoteHistory: IHistoryV1[] = [];
    bankInfoLacour: bankInfo;
    orderTotal = 0;

    scale: number = 0;
    cu: number = 0;
    orderAmountTTC = 0;
    lastid = 0;
    showCommand: boolean = true;
    showQuote: boolean = false;

    constructor(private api: IxellAPIService, private headerService: HeaderService, private errorService: ErrorService) { }

    ngOnInit() {
        this.headerService.changeTitle("IxellWebLab");
        this.headerService.changeCanBack(true);
        this.headerService.changeLogo(null);

        // Insère toutes les commandes effectuées 
        this.historySub = this.api.displayHistoryUser().subscribe(data => {
            if (data) {
                data.forEach(el => {
                    el.amountTotal = +el.amountTotal.toFixed(2);
                })
                data.forEach(element => {
                    var transDateUTC = new Date(Date.UTC(element.transDate.getFullYear(), element.transDate.getMonth(), element.transDate.getDate(), element.transDate.getHours(), element.transDate.getMinutes()));
                    element.transDate = transDateUTC;
                    if (element.transStatus == 17 || element.transStatus == 18)
                        this.quoteHistory.push(element);
                    else
                        this.orderHistory.push(element);
                })
            }
            if (this.historySub != null) this.historySub.unsubscribe();
            // Insère le RIB de lacour
            this.ribSub = this.api.getBankInfo().subscribe(data => {
                if (data) {
                    this.bankInfoLacour = data;
                } else {
                    this.bankInfoLacour = null;
                }
                if (this.ribSub != null) this.ribSub.unsubscribe();
            }, error => {
                this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "displayRibLacour", new Date().toString());
                if (this.ribSub != null) this.ribSub.unsubscribe();
                console.log(error);
            });
        }, error => {
            this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "displayHistoryUser", new Date().toString());
            if (this.historySub != null) this.historySub.unsubscribe();
            console.log(error);
        });
    }

    ngOnDestroy() {
        if (this.historySub != null) this.historySub.unsubscribe();
        if (this.ribSub != null) this.ribSub.unsubscribe();
    }


    displayRibModal() {
        let modal = document.getElementById("modalRIB");
        modal.style.display = "block";
    }

    closeRibModal() {
        // Ferme la modal
        let modal = document.getElementById("modalRIB");
        modal.style.display = "none";
    }


    chequePayment() {
        let modal = document.getElementById("ModalCheque");
        modal.style.display = "block";
    }

    closeChequePayment() {
        let modal = document.getElementById("ModalCheque");
        modal.style.display = "none";
    }

    toggleCommand() {
        this.showCommand = true;
        this.showQuote = false;
    }

    toggleQuote() {
        this.showCommand = false;
        this.showQuote = true;
    }
}
